import React, { useState, useEffect } from "react";
import Header from "../Components/CustomerVisit/Header";
import CustomerVisitOverview from "../Components/CustomerVisit/CustomerVisitOverview";
import { getCustomerVisit } from "../actions/CustomerVisitAction";
import { getCustomerVisitsWithQueries } from "../services/customerVisit";
import { getDistributorNames } from "../Common/functions";

const CustomerVisit = ({ userRole }) => {
  const [data, setData] = useState([]);
  const [stats, setStats] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  function getTotalPages(totalItems, itemsPerPage) {
    if (itemsPerPage <= 0) return 0; // avoid division by zero
    return Math.ceil(totalItems / itemsPerPage);
  }

  const getApplicationReport1 = async () => {
    setData([]);
    setLoading(true);

    try {
      const result = await getCustomerVisitsWithQueries({
        category: "customer visit",
        page_size: itemsPerPage,
        page_number: currentPage,
        distributor_name: getDistributorNames(),
        search_term: searchTerm,
      });

      if (result?.data) {
        setData(result.data.items);
        setCurrentPage(result.data.current_page);
        setTotalCount(result.data.total_records);
        setTotalPages(getTotalPages(result.data.total_records, itemsPerPage));
      } else {
        console.error("Unexpected response format:", result);
      }
    } catch (error) {
      console.error("Error fetching customer visits:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    } else {
      getApplicationReport1();
    }
  }, [searchTerm]);

  useEffect(() => {
    getApplicationReport1();
  }, [itemsPerPage, currentPage]);

  return (
    <div>
      <Header stats={stats} userRole={userRole} />
      <CustomerVisitOverview
        data={data}
        loading={loading}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        setCurrentPage={setCurrentPage}
        setSearchTerm={setSearchTerm}
        setItemsPerPage={setItemsPerPage}
        itemsPerPage={itemsPerPage}
      />
    </div>
  );
};

export default CustomerVisit;
